import { render, staticRenderFns } from "./RouteLoading.vue?vue&type=template&id=24aa7254&scoped=true&"
import script from "./RouteLoading.vue?vue&type=script&lang=js&"
export * from "./RouteLoading.vue?vue&type=script&lang=js&"
import style0 from "./RouteLoading.vue?vue&type=style&index=0&id=24aa7254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa7254",
  null
  
)

export default component.exports